module.exports = __webpack_public_path__ + "img/neudorf-review-filter.180f8cba.jpg";